import { render, staticRenderFns } from "./MessagesView.vue?vue&type=template&id=34ab99e8&scoped=true"
import script from "./MessagesView.vue?vue&type=script&lang=js"
export * from "./MessagesView.vue?vue&type=script&lang=js"
import style0 from "./MessagesView.vue?vue&type=style&index=0&id=34ab99e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ab99e8",
  null
  
)

export default component.exports